import axios from 'axios';
import { Api } from '../../../services/interceptor';
import { QUERY_KEY } from '../../../services/queryEndPoint';
import type { IApiResponse } from '../../../services/api';
import type { IPlayerProfileResponse } from '../../leaguesHome/tournaments/tournamentsDetails/matches/matchesDetails/types/playerProfile';

type ApiPayload<T> = T | IApiResponse<T>;

const unwrapApiPayload = <T>(payload: ApiPayload<T>): T => {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    return payload.data as T;
  }
  return payload as T;
};

/**
 * Plain axios call (not the shared `Api` instance) so a missing-profile 404 for a
 * brand-new social user never hits the shared response interceptor, which force-clears
 * the auth cookie and hard-redirects on "User not found" / 401 responses.
 */
export async function fetchExistingPlayerProfile(
  sub: string,
  accessToken: string,
): Promise<IPlayerProfileResponse | null> {
  try {
    const { data } = await axios.get<ApiPayload<IPlayerProfileResponse>>(
      `${import.meta.env.VITE_API_URL}${QUERY_KEY.getPlayerProfileById.replace('playerId', sub)}`,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    return unwrapApiPayload(data);
  } catch {
    return null;
  }
}

export interface SocialPlayerCreationRequest {
  userName: string;
  playerId: string;
  emailId: string | null;
  phoneNo: string | null;
  countryCode: number | null;
}

export async function createSocialPlayer(payload: SocialPlayerCreationRequest): Promise<void> {
  await Api.post('/player', payload);
}
